import BaseFeature from '../../foundation/base/base';
export default class Menu extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.initDomCache();
		this.navItems = this.el.querySelectorAll('[data-js="nav-item-btn"]')
		this.close = this.el.querySelectorAll('[data-js="close"]')

		this.addEventListeners();
	}

	addEventListeners() {
		this.navItems.forEach((item) => {

			this.addEventListener(item, 'click', (e) => {
				e.preventDefault();

				if (e.target.parentNode.classList.contains('o-menu__nav-item--active')) {
					e.target.parentNode.classList.remove('o-menu__nav-item--active');
				} else {
					const activeItem = this.el.querySelector('.o-menu__nav-item--active')
					if (activeItem) {
						activeItem.classList.remove('o-menu__nav-item--active')
					}
					this.openMenu(e.target);
				}
			})
		})

		this.close.forEach((closeBtn) => {
			this.addEventListener(closeBtn, 'click', (e) => {
				e.preventDefault();
				this.closeMenu(e);
			});

		})

		this.addEventListener(window.features.dom.body, 'click', (e) => {
			if (!this.el.contains(e.target)) {
				this.closeMenu();
			};
		});

		this.addEventListener(this.el, 'keydown', (e) => {

			if (this.el.classList.contains('o-menu--open')) {
				if (e.keyCode === 27) {
					e.preventDefault();
					this.closeMenu();
				}
			}
		});

	}

	/* ------------------------------------ *\
				General methods
	\* ------------------------------------ */

	openMenu(navItemBtn) {
		if (!navItemBtn.parentNode.classList.contains('o-menu__nav-item--active')) {
			this.el.classList.add('o-menu--open');
			navItemBtn.parentNode.classList.add('o-menu__nav-item--active');
			navItemBtn.setAttribute('aria-expanded', 'true');
			navItemBtn.nextElementSibling.setAttribute('aria-hidden', 'false');
		}
	}

	closeMenu() {
		const navItem = this.el.querySelector('.o-menu__nav-item--active')
		this.el.classList.remove('o-menu--open');

		if (navItem) {
			navItem.firstChild.nextElementSibling.setAttribute('aria-expanded', 'false');
			navItem.firstChild.nextElementSibling.nextElementSibling.setAttribute('aria-hidden', 'true');
			navItem.classList.remove('o-menu__nav-item--active')

		}
	}
}
